export const getIsEvoVerificationPerformed = (response) => ["success", "failed"].includes(response !== null && response !== void 0 ? response : "");
//# sourceMappingURL=getIsEvoVerificationPerformed.js.map